const styles = {
  chatWrapper: {
    display: 'flex',
    flexDirection: 'column',
    background: '#FFF',
    height: '100%',
  },
  chatHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: '54px',
    paddingLeft: 50,
    paddingRight: 35,
    backgroundColor: 'hsl(0, 0%, 97%)',
  },
  chatHeaderTitle: {
    color: '#EE4360',
    margin: '0 0 0 6px',
  },
  chatHeaderButton: {
    border: 'none',
    background: 'none',
    color: '#7C7C7C',
    fontSize: 18,
    textDecoration: 'underline',
    textDecorationColor: 'transparent',
    transition: ' text-decoration-color 0.3s ease',
    outline: 'none',
    '&:hover': {
      textDecorationColor: '#7C7C7C',
    },
  },
  chatMain: {
    display: 'flex',
    border: '1px solid #DFE2E5',
    height: 'calc(100% - 55px)',
    '&>section': {
      '&:first-child': {
        width: '20%',
        maxHeight: '100%',
      },
      '&:last-child': {
        width: '80%',
        maxHeight: '100%',
      },
    },
  },
  iconTitleBlock: {
    display: 'flex',
    alignItems: 'baseline',
  },
  rightBlock: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  spacedBlock: {
    marginLeft: '5px',
    marginRight: '5px',
  },
}
export default styles



// WEBPACK FOOTER //
// ./src/Containers/Chat/styles.js